import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import RoundedModal from '../../../../../../molecules/RoundedModal'
import DeleteVersionForm from './form'

const DeleteVersionDialog = React.forwardRef(function DeleteVersionDialog ({ blueprint, onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, version: null })

  const close = useCallback(() => {
    setDialogState({ open: false, version: null })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: (version) => {
      setDialogState({ open: true, version: structuredClone(version) })
    }
  }), [setDialogState])

  return (
    <RoundedModal
      title='Delete Version'
      open={dialogState.open}
      onClose={close}
      size='md'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <DeleteVersionForm
            blueprint={blueprint}
            version={dialogState.version}
            onComplete={handleComplete}
            onCancel={close}
          />
        ) : null}
      </div>
    </RoundedModal>
  )
})

DeleteVersionDialog.propTypes = {
  blueprint: PropTypes.object.isRequired,
  onComplete: PropTypes.func
}

DeleteVersionDialog.defaultProps = {
  onComplete: () => {}
}

export default DeleteVersionDialog
